export default __webpack_public_path__ + "static/media/decorations-background.d86562c0.svg";